import React from "react";
import Grid from "@mui/material/Grid";
import { TextField } from "@mui/material";
import ClientsComboBox from "Components/Client/ClientsComboBox";
import FilesCombobox from "Components/Files/FilesCombobox";
import PriceField from "Components/UI/Form/PriceField";

export default function ClientBankFileFormGeneral({
  formData,
  files,
  clients,
  handleInputChange,
}) {
  return (
    <Grid container spacing={3} sx={{ marginTop: "10px" }}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Id"
          disabled
          label="Id"
          value={formData.Id}
          size="small"
          color="primary"
          fullWidth
          margin="dense"
          type="number"
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="Amount"
          onChange={(newVal) => handleInputChange("Amount", newVal)}
          label="Belopp"
          value={formData.Amount === null ? 0 : formData.Amount}
          size="small"
          color="primary"
          fullWidth
          margin="dense"
          type="number"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <ClientsComboBox
          label={"Klient"}
          clients={clients}
          selectedID={formData.ClientId}
          onChange={(newVal) => handleInputChange("ClientId", newVal)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FilesCombobox
          label="Fil"
          files={files}
          selectedFileID={formData.FileId}
          onChange={(newVal) => handleInputChange("FileId", newVal)}
        />
      </Grid>
    </Grid>
  );
}
